import { render, staticRenderFns } from "./AddonHistoryDialog.vue?vue&type=template&id=39f86390"
import script from "./AddonHistoryDialog.vue?vue&type=script&lang=js"
export * from "./AddonHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f86390')) {
      api.createRecord('39f86390', component.options)
    } else {
      api.reload('39f86390', component.options)
    }
    module.hot.accept("./AddonHistoryDialog.vue?vue&type=template&id=39f86390", function () {
      api.rerender('39f86390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/AddonHistoryDialog.vue"
export default component.exports